import {Persona} from '../models/persona';
import {User} from '../models/user';
export class PersonaData {
  title: string;
  personaList: Array<Persona>;
  user: User;
}
